import { render, staticRenderFns } from "./InsuranceTests.vue?vue&type=template&id=077b0775"
import script from "./InsuranceTests.vue?vue&type=script&lang=js"
export * from "./InsuranceTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports